import React from 'react';
import { ArrowDown } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="relative bg-[#F5F1E8] pt-24 pb-16 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Small header text */}
        <div className="text-center mb-4">
          <p className="text-[#8B6F47] text-sm tracking-widest uppercase">
            FROM SUNRISE, TO BEYOND.
          </p>
        </div>

        {/* Main Heading */}
        <div className="text-center mb-8">
          <h1 className="text-5xl md:text-7xl font-bold text-[#2C2416] mb-4 tracking-tight">
            PROTEIN-PACKED.<br />SMART START.
          </h1>
          <p className="text-xl md:text-2xl text-[#5C4033] mb-2">
            Nutritious fuel for hours. Ready in seconds.
          </p>
          <p className="text-lg text-[#8B6F47] mb-8">
            Quality nutrition for everyone who needs to perform.
          </p>
        </div>

        {/* Product Badges */}
        <div className="flex flex-wrap justify-center gap-3 mb-8">
          <span className="px-4 py-2 bg-white border border-[#E5DCC8] rounded-full text-xs font-medium text-[#5C4033]">
            RS · Reduced Sugar
          </span>
          <span className="px-4 py-2 bg-white border border-[#E5DCC8] rounded-full text-xs font-medium text-[#5C4033]">
            HF · High Fibre
          </span>
          <span className="px-4 py-2 bg-white border border-[#E5DCC8] rounded-full text-xs font-medium text-[#5C4033]">
            GF · Gluten Free
          </span>
          <span className="px-4 py-2 bg-white border border-[#E5DCC8] rounded-full text-xs font-medium text-[#5C4033]">
            NG · Non-GMO
          </span>
          <span className="px-4 py-2 bg-white border border-[#E5DCC8] rounded-full text-xs font-medium text-[#5C4033]">
            PB · Plant-Based
          </span>
          <span className="px-4 py-2 bg-white border border-[#E5DCC8] rounded-full text-xs font-medium text-[#5C4033]">
            NS · No Added Salt
          </span>
          <span className="px-4 py-2 bg-white border border-[#E5DCC8] rounded-full text-xs font-medium text-[#5C4033]">
            2-IN-1 · Bowl or Shake
          </span>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-12">
          <a
            href="#shop"
            className="px-8 py-4 bg-[#8B6F47] text-white rounded-full hover:bg-[#5C4033] transition-colors font-medium text-center"
          >
            Shop GUAG — From R59
          </a>
          <a
            href="#who"
            className="px-8 py-4 bg-white border-2 border-[#8B6F47] text-[#8B6F47] rounded-full hover:bg-[#8B6F47] hover:text-white transition-colors font-medium text-center"
          >
            Who Is It For?
          </a>
        </div>

        {/* Product Image */}
        <div className="relative max-w-5xl mx-auto mb-8">
          <img
            src="https://d64gsuwffb70l.cloudfront.net/6851587676ae218610324179_1769273766653_9129f837.png"
            alt="GUAG Products"
            className="w-full h-auto rounded-2xl shadow-2xl"
          />
          
          {/* Nutrition Stats Overlay */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 w-full max-w-3xl">
            <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-xl">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#8B6F47] mb-1">9.5g</div>
                  <div className="text-sm text-[#5C4033] uppercase tracking-wide">PROTEIN</div>
                  <div className="text-xs text-[#8B6F47]">per serving</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#8B6F47] mb-1">3.2g</div>
                  <div className="text-sm text-[#5C4033] uppercase tracking-wide">FIBRE</div>
                  <div className="text-xs text-[#8B6F47]">per serving</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#8B6F47] mb-1">21+</div>
                  <div className="text-sm text-[#5C4033] uppercase tracking-wide">VITAMINS</div>
                  <div className="text-xs text-[#8B6F47]">& minerals</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#8B6F47] mb-1">4g</div>
                  <div className="text-sm text-[#5C4033] uppercase tracking-wide">SUGAR</div>
                  <div className="text-xs text-[#8B6F47]">reduced formula</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="text-center">
          <p className="text-sm text-[#8B6F47] mb-2">Scroll to explore</p>
          <ArrowDown className="mx-auto text-[#8B6F47] animate-bounce" size={24} />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;